export default __webpack_public_path__ + "static/media/img_step_lucia05_w.0750941e.jpg";